import DirectorInfo from './DirectorInfo-view';

export default DirectorInfo;
